<template>
  <a class="powered-by flex items-center justify-center text-gray text-xs no-underline">
    <img src="../../../../../../assets/images/icons/chat-widget/high-voltage.png"
         alt="powered by amio"
         class="powered-by__icon mr-0.5">
    Powered by
    <span class="powered-by__amio ml-1 font-bold"
          :style="styles"
    >
      Amio
    </span>
  </a>
</template>

<script>
export default {
  name: 'ChatPreviewFooter',

  props: {
    themeConfig: {
      type: Object,
      required: true
    }
  },

  computed: {
    styles() {
      return {
        color: this.themeConfig.launcher.bg.includes('gradient') ?
          this.themeConfig.sentMessage.bg :
          this.themeConfig.launcher.bg
      }
    }
  }
}
</script>
